<template>
  <VDialog
    :value="isLogOutConfirmVisible"
    max-width="360"
    @input="!$event && answerLogOutConfirm(false)"
  >
    <VCard>
      <VCardText class="subheading pt-4">
        You have unpublished changes. Log out and lose them?
      </VCardText>
      <VCardActions>
        <VSpacer />
        <VBtn flat @click="answerLogOutConfirm(false)">Cancel</VBtn>
        <VBtn flat color="red darken-2" @click="answerLogOutConfirm(true)"
          >Log Out</VBtn
        >
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'LogOutConfirmModal',
  computed: {
    ...mapGetters('auth', ['isLogOutConfirmVisible']),
  },
  methods: {
    ...mapActions('auth', ['answerLogOutConfirm']),
  },
}
</script>
